import { render } from "./payment-method.vue?vue&type=template&id=f22fae56"
import script from "./payment-method.vue?vue&type=script&setup=true&lang=js"
export * from "./payment-method.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/payment-method.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f22fae56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f22fae56', __exports__)) {
    console.log('reload')
    api.reload('f22fae56', __exports__)
  }
  
  module.hot.accept("./payment-method.vue?vue&type=template&id=f22fae56", () => {
    console.log('re-render')
    api.rerender('f22fae56', render)
  })

}


export default __exports__